import React, { Component } from 'react';
import { Container, Accordion, Icon } from 'semantic-ui-react';
import { PtSelect, PtSelectAndEstimate, PtInputAndEstimate, PtInputAndSelectAndEstimate } from '../../../grit-utilities';
import ScrollArea from 'react-scrollbar';
import DropdownLib from '../../../DropdownLib';
import '../../../index.css';

export default class Base extends Component {

    constructor(props) {
        super(props);
        const { csModel } = this.props;
        this.state = csModel.bModel;
    }

    render() {

        const {
            baseTypeOptions,
            baseTrtOptions,
            fabricOptions,
            sgTreatmentOptions,
            sgStrengthOptions} = DropdownLib.getDropdowns().CS_Base;

        const {dptOptions} = DropdownLib.getDropdowns().CS_LastProjectSurf;

        return (
            <Container>
                <ScrollArea
                    speed={1}
                    className={!window.mobileAndTabletcheck() ? "area_desktop" : "area_mobile"}
                    contentClassName="content"
                    smoothScrolling={true}>

                    <Accordion fluid>
                        <Accordion.Title className="accordion-title">
                            <Icon name='dropdown' />
                            Top Base Layer
                        </Accordion.Title>
                        <Accordion.Content>

                            <PtSelectAndEstimate label="Top Base Type" options={baseTypeOptions} defaultVal={this.state.topBaseType} disabled={this.props.disabled}
                                onChange={this.onChangeDropdownEstimated} name="topBaseType" estimated={this.state.topBaseTypeEst} />

                            <PtSelectAndEstimate label="Top Base Depth" options={dptOptions} defaultVal={this.state.topBaseDpt} disabled={this.props.disabled}
                                onChange={this.onChangeDropdownEstimated} name="topBaseDpt" estimated={this.state.topBaseDptEst} />

                            <PtInputAndEstimate inputType="year" placeholder="1900" label="Top Base Year" value={this.state.topBaseYear} onChange={this.onInputChange}
                                name="topBaseYear" estimated={this.state.topBaseYearEst} disabled={this.props.disabled} />

                            <PtSelect label="Top Base Treatment" options={baseTrtOptions} defaultVal={this.state.topBaseTrt} disabled={this.props.disabled}
                                onChange={this.onChangeDropdown} name="topBaseTrt" />

                        </Accordion.Content>
                    </Accordion>
                    
                    <Accordion fluid>
                        <Accordion.Title className="accordion-title">
                            <Icon name='dropdown' />
                            Bottom Base Layer
                        </Accordion.Title>
                        <Accordion.Content>

                            <PtSelectAndEstimate label="Bottom Base Type" options={baseTypeOptions} defaultVal={this.state.bottomBaseType} disabled={this.props.disabled}
                                onChange={this.onChangeDropdownEstimated} name="bottomBaseType" estimated={this.state.bottomBaseTypeEst} />

                            <PtSelectAndEstimate label="Bottom Base Depth" options={dptOptions} defaultVal={this.state.bottomBaseDpt} disabled={this.props.disabled}
                                onChange={this.onChangeDropdownEstimated} name="bottomBaseDpt" estimated={this.state.bottomBaseDptEst} />

                            <PtInputAndEstimate inputType="year" placeholder="1900" label="Bottom Base Year" value={this.state.bottomBaseYear} onChange={this.onInputChange}
                                name="bottomBaseYear" estimated={this.state.bottomBaseYearEst} disabled={this.props.disabled} />

                            <PtSelect label="Bottom Base Treatment" options={baseTrtOptions} defaultVal={this.state.bottomBaseTrt} disabled={this.props.disabled}
                                onChange={this.onChangeDropdown} name="bottomBaseTrt" />

                            <PtSelect label="Fabric" options={fabricOptions} defaultVal={this.state.fabric} disabled={this.props.disabled}
                                onChange={this.onChangeDropdown} name="fabric" />

                        </Accordion.Content>
                    </Accordion>

                    <Accordion fluid>
                        <Accordion.Title className="accordion-title">
                            <Icon name='dropdown' />
                            Subgrade
                        </Accordion.Title>
                        <Accordion.Content>

                            <PtInputAndSelectAndEstimate inputType="number" placeholder="0"
                                label="Subgrade Strength" value={this.state.subgradeStrength} onChange={this.onInputChangeDropdownEstimated} options={sgStrengthOptions}
                                name="subgradeStrength" defaultVal={this.state.subgradeStrengthType} estimated={this.state.subgradeStrengthEst} disabled={this.props.disabled} />

                            <PtInputAndEstimate inputType="year" placeholder="1900"
                                label="Last Subgrade Imp. Year" value={this.state.lastSGImpYear} onChange={this.onInputChange}
                                name="lastSGImpYear" estimated={this.state.lastSGImpYearEst} disabled={this.props.disabled} />

                            <PtSelect label="Subgrade Treatment" options={sgTreatmentOptions} defaultVal={this.state.subgradeTrt} disabled={this.props.disabled}
                                onChange={this.onChangeDropdown} name="subgradeTrt" />

                        </Accordion.Content>
                    </Accordion>

                </ScrollArea>
            </Container>
        );
    }

    onChangeDropdown = (e) => {
        const { target } = e;
        const { name, value } = target;
        this.props.triggerNeedSave();
        // eslint-disable-next-line
        this.setState({ [name]: parseInt(value) });
    }

    onChangeDropdownEstimated = (e) => {
        const { target } = e;
        const { name, value } = target;
        this.props.triggerNeedSave();
        console.log("its changed");
        // Determine if Dropdown value or Estimated value was changed
        // eslint-disable-next-line
        if ((parseFloat(value) === parseInt(value)) && !isNaN(value))
            // eslint-disable-next-line
            this.setState({ [name]: parseInt(value) });
        else
            // eslint-disable-next-line
            this.setState({ [name]: value });
        //this.setState({ [name]: value===''?0:value });
    }

    onInputChange = (e) => {
        const { name, value } = e.target;
        this.props.triggerNeedSave();
        // eslint-disable-next-line
        this.setState({ [name]: value === '' ? null : parseFloat(value) });

    }

    onInputChangeDropdownEstimated = (e) => {
        const { name, value } = e.target;
        this.props.triggerNeedSave();

        // Determine what was changed
        // eslint-disable-next-line
        if ((parseFloat(value) == parseInt(value)) && !isNaN(value)) // Dropdown value was changed
            // eslint-disable-next-line
            this.setState({ [name]: parseInt(value) });

        else {                                                        // Estimated or input value was changed
            if (name === 'subgradeStrength') {
                // eslint-disable-next-line
                this.setState({ [name]: value === '' ? null : parseFloat(value) });
            }
            else this.setState({ [name]: value });
            
        }

    }

    componentDidUpdate() {
        //console.log(this.state);
        this.props.csModel.bModel = this.state;
    }
}


// WEBPACK FOOTER //
// ./src/layers/tabs/cons-segment/base.js